/* ============================================================
   Cart Double The Fun — add-to-cart handler
   Standalone, additive script for the custom DTF carousel cards.
   Uses the theme's existing EventBus("cart:updated") convention
   so the drawer + tiered bar + price breakdown all refresh the
   same way they do for any other add-to-cart action.
   ============================================================ */

(function () {
	"use strict";

	function onAddClick(event) {
		var button = event.target.closest(".js-product-card-button");
		if (!button || !button.closest(".cart-dtf")) return;
		if (button.disabled) return;

		var variantId = button.getAttribute("data-variant-id");
		if (!variantId) return;

		button.disabled = true;
		button.classList.add("is-loading");

		fetch("/cart/add.js", {
			method: "POST",
			headers: { "Content-Type": "application/json", Accept: "application/json" },
			body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
		})
			.then(function (res) {
				if (!res.ok) {
					return res.json().then(function (err) {
						throw err;
					});
				}
				return res.json();
			})
			.then(function () {
				if (window.themeCore && window.themeCore.EventBus) {
					window.themeCore.EventBus.emit("cart:updated", { params: [{ noOpen: true }] });
				}
				button.classList.remove("is-loading");
				button.classList.add("is-added");
				setTimeout(function () {
					button.classList.remove("is-added");
					button.disabled = false;
				}, 1500);
			})
			.catch(function (err) {
				console.warn("[Double The Fun] add to cart failed", err);
				button.classList.remove("is-loading");
				button.disabled = false;
			});
	}

	document.addEventListener("click", onAddClick);
})();
